import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { EntityIdParams } from "models/propTypes/urlParamsTypes";
//#endregion
//#region components
import {
  PageLayouts,
  useMountedState,
  useNavigationHistory,
  RouteBreadCrumb,
  useAPIRequestKeyRef,
} from "components/common";
import IncomingInvoiceViewInner from "./viewInner";
import { useParams } from "react-router-dom";
import { ErrorView } from "components/error";
import { useIncomingInvoiceService } from "serviceHooks";
//#endregion

const IncomingInvoiceView: React.FC = () => {
  const incomingInvoiceService = useIncomingInvoiceService();
  const urlParams = useParams<EntityIdParams>();
  const id = Number.parseInt(urlParams.id ?? "0");

  const { getMounted } = useMountedState();
  const { goBack } = useNavigationHistory();

  const [notFound, setNotFound] = React.useState<boolean>();
  const [invoice, setInvoice] = React.useState<WintSuperkollAPIModel.IncomingInvoice>();
  const [key, setKey] = React.useState(0);

  const { apiRequestKeyRef, updateKey } = useAPIRequestKeyRef();

  const loadIncomingInvoice = (
    onSuccess?: (incomingInvoice: WintSuperkollAPIModel.IncomingInvoice) => void,
    onError?: () => void
  ) => {
    const currentKey = updateKey();

    incomingInvoiceService
      .get(id, currentKey)
      .then((result) => {
        if (getMounted() && result.key === apiRequestKeyRef.current) {
          setNotFound(false);
          setInvoice(result.data);
          setKey(key + 1);
        }

        onSuccess && onSuccess(result.data);
      })
      .catch(() => {
        if (invoice) {
          setTimeout(() => {
            goBack();
          }, 1000);
          onError && onError();
        } else setNotFound(true);
      });
  };

  React.useEffect(() => {
    setInvoice(undefined);
    loadIncomingInvoice();
  }, [id]);

  return notFound ? (
    <ErrorView />
  ) : (
    <>
      <PageLayouts.EntityFullScreen
        entityKey={`incoming-invoice`}
        id={invoice?.id ?? 0}
        navigation={<RouteBreadCrumb current={invoice?.supplier?.name ?? ""} showHome />}
      >
        <IncomingInvoiceViewInner
          key={id}
          invoice={invoice}
          reloadKey={key}
          loadIncomingInvoice={loadIncomingInvoice}
        />
      </PageLayouts.EntityFullScreen>
    </>
  );
};

export default IncomingInvoiceView;
